/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any): any => ({
  async show(data: any) {
    return camelize(
      await $axios.get(`/posting-videos/${data.id}`, {
        params: snakelize(data),
      })
    );
  },

  async downloadUrl(data: any) {
    return camelize(
      await $axios.get(`/posting-videos/${data.id}/download-url`, {
        params: snakelize(data),
      })
    );
  },
});
